const errorRoutes = [
    {
        path: '*',
        redirect: 'login',
    },
];

export default errorRoutes;
